import React from "react";
import moment from "moment";

import {
	IcCancelCarL,
	IcCarL,
	IcCheckL,
	IcClockL,
	IcStatusTrip1,
	IcStatusTrip2,
	IcStatusTrip3,
	IcStatusTrip4,
	IcStatusTrip5,
} from "../../common/svg";

import insurance_polish from "../../../static/images/svg/insurance-polish.svg";

/* Active Status: active when index number <= trip status number*/

const TextStatusStep = {
	STEP1: "Gửi yêu cầu",
	STEP2: "Duyệt yêu cầu",
	STEP3: "Thanh toán cọc",
	STEP4: "Khởi hành",
	STEP5: "Kết thúc",
};

const STATUS_STEP = [
	{ id: 1, title: TextStatusStep.STEP1, ic: <IcStatusTrip1 /> },
	{ id: 2, title: TextStatusStep.STEP2, ic: <IcStatusTrip2 /> },
	{ id: 3, title: TextStatusStep.STEP3, ic: <IcStatusTrip3 /> },
	{ id: 4, title: TextStatusStep.STEP4, ic: <IcStatusTrip4 /> },
	{ id: 5, title: TextStatusStep.STEP5, ic: <IcStatusTrip5 /> },
];

const StepItem = ({ ic, title, active, insSupport }) => {
	return (
		<div className={`step-by-step__item ${active ? "active" : ""}`}>
			<h5 className="wrap-svg number-step">
				{ic}
				{!!insSupport && <img src={insurance_polish} />}
			</h5>
			<h6 className="title-step">{title}</h6>
		</div>
	);
};

export const StepBarStatus = ({ active, insSupport }) => {
	return (
		<div className="step-by-step">
			{STATUS_STEP.map((step, idx) => (
				<StepItem
					key={step.id}
					ic={step.ic}
					title={step.title}
					active={idx <= active}
					insSupport={insSupport && idx === 3}
				/>
			))}
		</div>
	);
};

const StepBar = ({ status, insSupport }) => {
	if (status >= 25) {
		return <StepBarStatus active={4} insSupport={insSupport} />;
	}
	if (status >= 5) {
		return <StepBarStatus active={3} insSupport={insSupport} />;
	}
	if (status >= 4) {
		return <StepBarStatus active={2} insSupport={insSupport} />;
	}
	if (status >= 2) {
		return <StepBarStatus active={1} insSupport={insSupport} />;
	}
	if (status >= 1) {
		return <StepBarStatus active={0} insSupport={insSupport} />;
	}
};

const StatusTripContent = ({ trip, countdown, isOwner }) => {
	if (isOwner) {
		if (trip.status >= 25)
			return (
				<>
					<StepBar status={trip.status} insSupport={trip.insSupport} />
					<div className="booking-status noti">
						<div className="wrap-svg">
							<IcCheckL />
						</div>
						<div className="booking-info">
							<p className="title">
								Chuyến thuê của khách đã kết thúc.{" "}
								{trip.status === 25 && trip.needReview === 1 && "Bạn hãy để lại nhận xét cho chuyến của mình."}
							</p>
						</div>
					</div>
				</>
			);

		if (trip.status >= 23)
			return (
				<div className="booking-status error">
					<div className="wrap-svg">
						<IcCancelCarL />
					</div>
					<div className="booking-info">
						<p className="title">
							Chuyến đã bị huỷ. Lý do: {trip.cancelReason && trip.cancelReason !== "" && trip.cancelReason}
							{trip.cancelComment && trip.cancelComment !== "" && " - " + trip.cancelComment}
						</p>
					</div>
				</div>
			);

		if (trip.status >= 21)
			return (
				<div className="booking-status error">
					<div className="wrap-svg">
						<IcCancelCarL />
					</div>
					<div className="booking-info">
						<p className="title">
							Chuyến đã bị huỷ. Lý do: {trip.cancelReason && trip.cancelReason !== "" && trip.cancelReason}
							{trip.cancelComment && trip.cancelComment !== "" && " - " + trip.cancelComment}
						</p>
					</div>
				</div>
			);

		if (trip.status >= 20)
			return (
				<div className="booking-status error">
					<div className="wrap-svg">
						<IcCancelCarL />
					</div>
					<div className="booking-info">
						<p className="title">
							Bạn đã từ chối chuyến. Lý do:{" "}
							{trip.rejectReason && trip.rejectReason !== "" ? `${trip.rejectReason}` : `${trip.rejectComment}`}
						</p>
					</div>
				</div>
			);

		if (trip.status >= 5)
			return (
				<>
					<StepBar status={trip.status} insSupport={trip.insSupport} />
					<div className="booking-status noti">
						<div className="wrap-svg">
							<IcCarL />
						</div>
						<div className="booking-info">
							<p className="title">Chuyến thuê của khách sẽ kết thúc vào </p>
							<span className="countdown">{moment(trip.tripDateTo).format("HH:mm, DD/MM/YYYY")}</span>
						</div>
					</div>
				</>
			);

		if (trip.status >= 4)
			return (
				<>
					<StepBar status={trip.status} insSupport={trip.insSupport} />
					<div className="booking-status noti">
						<div className="wrap-svg">
							<IcClockL />
						</div>
						<div className="booking-info">
							<p className="title">Chuyến thuê của khách sẽ bắt đầu vào</p>
							<span className="countdown">{moment(trip.tripDateFrom).format("HH:mm, DD/MM/YYYY")}</span>
						</div>
					</div>
				</>
			);

		if (trip.status >= 2)
			return (
				<>
					<StepBar status={trip.status} insSupport={trip.insSupport} />
					<div className="booking-status noti">
						<div className="wrap-svg">
							<IcClockL />
						</div>
						<div className="booking-info">
							<p className="title">Đang chờ khách thuê thanh toán tiền cọc</p>
							{countdown && countdown !== "" && <span className="countdown">{countdown}</span>}
						</div>
					</div>
				</>
			);

		if (trip.status >= 1)
			return (
				<>
					<StepBar status={trip.status} insSupport={trip.insSupport} />
					<div className="booking-status noti">
						<div className="wrap-svg">
							<IcClockL />
						</div>
						<div className="booking-info">
							<p className="title">Khách thuê đang chờ bạn duyệt yêu cầu</p>
							{countdown && countdown !== "" && <span className="countdown">{countdown}</span>}
						</div>
					</div>
				</>
			);
	} else {
		if (trip.status >= 25)
			return (
				<>
					<StepBar status={trip.status} insSupport={trip.insSupport} />
					<div className="booking-status">
						<div className="wrap-svg">
							<IcCheckL />
						</div>
						<div className="booking-info">
							<p className="title">
								Chuyến xe của bạn đã kết thúc.{" "}
								{trip.status === 25 && trip.needReview === 1 && "Bạn hãy để lại nhận xét cho chuyến của mình."}
							</p>
						</div>
					</div>
				</>
			);

		if (trip.status >= 23)
			return (
				<div className="booking-status error">
					<div className="wrap-svg">
						<IcCancelCarL />
					</div>
					<div className="booking-info">
						<p className="title">
							Chuyến đã bị huỷ. Lý do: {trip.cancelReason && trip.cancelReason !== "" && trip.cancelReason}
							{trip.cancelComment && trip.cancelComment !== "" && " - " + trip.cancelComment}
						</p>
					</div>
				</div>
			);

		if (trip.status >= 21)
			return (
				<div className="booking-status error">
					<div className="wrap-svg">
						<IcCancelCarL />
					</div>
					<div className="booking-info">
						<p className="title">
							Chuyến đã bị huỷ. Lý do: {trip.cancelReason && trip.cancelReason !== "" && trip.cancelReason}
							{trip.cancelComment && trip.cancelComment !== "" && " - " + trip.cancelComment}
						</p>
					</div>
				</div>
			);

		if (trip.status >= 20)
			return (
				<div className="booking-status error">
					<div className="wrap-svg">
						<IcCancelCarL />
					</div>
					<div className="booking-info">
						<p className="title">
							Chủ xe đã từ chối. Lý do:{" "}
							{trip.rejectReason && trip.rejectReason !== "" ? ` ${trip.rejectReason}` : ` ${trip.rejectComment}`}
						</p>
					</div>
				</div>
			);

		if (trip.status >= 5)
			return (
				<>
					<StepBar status={trip.status} insSupport={trip.insSupport} />
					<div className="booking-status">
						<div className="wrap-svg">
							<IcClockL />
						</div>
						<div className="booking-info">
							<p className="title">Chuyến xe của bạn sẽ kết thúc lúc</p>
							<span className="countdown">{moment(trip.tripDateTo).format("HH:mm, DD/MM/YYYY")}</span>
						</div>
					</div>
				</>
			);

		if (trip.status >= 4)
			return (
				<>
					<StepBar status={trip.status} insSupport={trip.insSupport} />
					<div className="booking-status">
						<div className="wrap-svg">
							<IcClockL />
						</div>
						<div className="booking-info">
							<p className="title">Chuyến xe của bạn sẽ bắt đầu vào</p>
							<span className="countdown">{moment(trip.tripDateFrom).format("HH:mm, DD/MM/YYYY")}</span>
						</div>
					</div>
				</>
			);

		if (trip.status >= 2)
			return (
				<>
					<StepBar status={trip.status} insSupport={trip.insSupport} />
					<div className="booking-status">
						<div className="wrap-svg">
							<IcClockL />
						</div>
						<div className="booking-info">
							<p className="title">Thanh toán cọc để hoàn thành yêu cầu của bạn</p>
							{countdown && countdown !== "" && <span className="countdown">{countdown}</span>}
						</div>
					</div>
				</>
			);

		if (trip.status >= 1)
			return (
				<>
					<StepBar status={trip.status} insSupport={trip.insSupport} />
					<div className="booking-status">
						<div className="wrap-svg">
							<IcClockL />
						</div>
						<div className="booking-info">
							<p className="title">Chờ chút nhé, chủ xe sẽ duyệt cho bạn</p>
							{countdown && countdown !== "" && <span className="countdown">{countdown}</span>}
						</div>
					</div>
				</>
			);
	}
	return null;
};

const StatusTrip = ({ trip, countdown, isOwner }) => {
	return (
		<div className="step-trip-container">
			<div className="m-container">
				<StatusTripContent trip={trip} countdown={countdown} isOwner={isOwner} />
			</div>
		</div>
	);
};

export default StatusTrip;
